/**
 * Cross-host "ga als jezelf"-navigatie (ADR-0028 self-handoff).
 *
 * De beheer-host en app-host hebben aparte sessies (cookie-jars). Om zonder
 * opnieuw in te loggen naar je eigen sessie op de andere host te gaan, minten
 * we een eenmalige self-handoff-token en navigeren we naar
 * `<host>/?handoff=<token>` — de bestemming wisselt 'm in (consume) en logt je
 * als jezelf in.
 *
 * Same-tab navigatie: de sessie op de huidige host blijft bestaan (host-only
 * cookie), dus je kunt altijd terug via de tegenovergestelde knop. Dat vermijdt
 * ook popup-blokkering die optreedt bij een window.open ná een async call.
 */
import { api } from '@shared/api/client';
import { handoffConsumeUrl, hostUrl } from '@shared/tenant-host';

export async function openSelfHandoff(host: string): Promise<void> {
  try {
    const { data } = await api.post<{ token: string }>('/api/v1/auth/handoff');
    window.location.href = handoffConsumeUrl(host, data.token);
  } catch {
    // Fallback: open de kale host (login) zodat de knop altijd iets doet.
    window.location.href = hostUrl(host);
  }
}
